import { File, FileText, Image as ImageIcon, Video, Music, FileArchive, Table, Code, FileSpreadsheet, Presentation } from 'lucide-react';
import { isImage, isVideo, isAudio, isPdf, isText, extOf } from './utils';

export interface FileVisual {
  Icon: typeof File;
  color: string;   // 图标颜色类
  bg: string;      // 图标底色类
  ring: string;    // 边框光晕
}

/* 红黑主色调：以红色明度变化 + 中性灰区分类型 */
const MAP: Record<string, FileVisual> = {
  image:  { Icon: ImageIcon,       color: 'text-red-300',     bg: 'bg-red-400/12',     ring: 'group-hover:shadow-red-500/25' },
  video:  { Icon: Video,           color: 'text-neutral-200', bg: 'bg-neutral-200/10', ring: 'group-hover:shadow-neutral-400/20' },
  audio:  { Icon: Music,           color: 'text-rose-400',    bg: 'bg-rose-400/12',    ring: 'group-hover:shadow-rose-500/25' },
  pdf:    { Icon: FileText,        color: 'text-red-500',     bg: 'bg-red-500/12',     ring: 'group-hover:shadow-red-600/25' },
  archive:{ Icon: FileArchive,     color: 'text-neutral-400', bg: 'bg-neutral-400/10', ring: 'group-hover:shadow-neutral-500/20' },
  sheet:  { Icon: FileSpreadsheet, color: 'text-red-400',     bg: 'bg-red-400/12',     ring: 'group-hover:shadow-red-500/25' },
  slides: { Icon: Presentation,    color: 'text-rose-300',    bg: 'bg-rose-300/12',    ring: 'group-hover:shadow-rose-400/25' },
  doc:    { Icon: FileText,        color: 'text-red-300',     bg: 'bg-red-300/12',     ring: 'group-hover:shadow-red-400/25' },
  code:   { Icon: Code,            color: 'text-neutral-300', bg: 'bg-neutral-300/10', ring: 'group-hover:shadow-neutral-400/20' },
  text:   { Icon: FileText,        color: 'text-neutral-300', bg: 'bg-neutral-300/10', ring: 'group-hover:shadow-neutral-400/20' },
  folder: { Icon: File,            color: 'text-red-400',     bg: 'bg-red-400/12',     ring: 'group-hover:shadow-red-500/25' },
  file:   { Icon: File,            color: 'text-neutral-400', bg: 'bg-neutral-400/10', ring: 'group-hover:shadow-neutral-500/20' },
};

export function fileVisual(mime?: string | null, name?: string): FileVisual {
  const ext = name ? extOf(name) : '';
  if (isImage(mime)) return MAP.image;
  if (isVideo(mime)) return MAP.video;
  if (isAudio(mime)) return MAP.audio;
  if (isPdf(mime)) return MAP.pdf;
  if (['zip', 'rar', '7z', 'tar', 'gz', 'bz2', 'xz'].includes(ext)) return MAP.archive;
  if (['xls', 'xlsx', 'csv'].includes(ext)) return MAP.sheet;
  if (['ppt', 'pptx', 'key'].includes(ext)) return MAP.slides;
  if (['doc', 'docx', 'md', 'rtf'].includes(ext)) return MAP.doc;
  if (['js', 'ts', 'tsx', 'jsx', 'json', 'html', 'css', 'py', 'go', 'rs', 'java', 'sh', 'yml', 'yaml', 'xml', 'sql'].includes(ext)) return MAP.code;
  if (isText(mime)) return MAP.text;
  return MAP.file;
}
